
import { useState } from 'react';
import { supabase, setCachedProfile } from '../../../supabaseClient';
import { useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const LoginForm = ({ setAuthError, clearMessages, onForgotPasswordClick }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    clearMessages();
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAuthError('');

    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email: formData.email,
        password: formData.password
      });

      if (error) throw error;

      // Prefetch profile immediately so UserDashboard has the real plan on the first render frame
      if (data?.user?.id) {
        try {
          const { data: profiles } = await supabase
            .from("profiles")
            .select("*")
            .eq("id", data.user.id);
          if (profiles && profiles.length > 0) {
            setCachedProfile(data.user.id, profiles[0]);
          }
        } catch (pErr) {
          console.warn("LoginForm: Profile prefetch warning:", pErr);
        }
      }

      navigate('/user-dashboard');
    } catch (err) {
      setAuthError(err.message || 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <form className="auth-form" onSubmit={handleLogin}>
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          className="form-input"
          required
          disabled={loading}
          autoComplete="email"
        />
      </div>

      <div className="form-group">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <label htmlFor="password" style={{ margin: 0 }}>Password</label>
          <button
            type="button"
            className="forgot-password-link"
            style={{
              background: 'none',
              border: 'none',
              color: '#3b82f6',
              fontSize: '0.875rem',
              cursor: 'pointer',
              padding: 0
            }}
            onClick={onForgotPasswordClick}
            disabled={loading}
          >
            Forgot Password?
          </button>
        </div>
        <div className="password-input-container">
          <input
            id="password"
            name="password"
            type={showPassword ? "text" : "password"}
            value={formData.password}
            onChange={handleChange}
            className="form-input"
            required
            disabled={loading}
            autoComplete="current-password"
          />
          <button
            type="button"
            className="password-toggle"
            onClick={togglePasswordVisibility}
            disabled={loading}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
          </button>
        </div>
      </div>

      <button
        type="submit"
        className="submit-button"
        disabled={loading}
      >
        {loading ? (
          <>
            <span className="loading-spinner">↻</span> Signing In...
          </>
        ) : 'Sign In'}
      </button>
    </form>
  );
};

export default LoginForm;